import { Link } from 'react-router-dom';
import { cn } from '@/utils/styles';
import { flexRender, Row } from '@tanstack/react-table';
import { TableCell, TableRow } from '@/components/ui/table';
import { Route } from '@/constants';

export function MyOffersRow({ row }: { row: Row<any> }) {
  const href = Route.BuyingOffer.replace(':offerId', row.original.id);

  return (
    <TableRow
      data-state={row.getIsSelected() && 'selected'}
      className={cn('bg-base-white hover:bg-gray-200/50', 'cursor-pointer')}
    >
      {row.getVisibleCells().map((cell) => {
        const content = flexRender(cell.column.columnDef.cell, cell.getContext());
        const disableRowLink = (cell.column.columnDef as any)?.meta?.disableRowLink;

        return (
          <TableCell key={cell.id} className="truncate px-0 py-0">
            {!disableRowLink ? (
              <Link
                to={href}
                className={cn('block h-full w-full px-2 py-3')}
                aria-label={`Open opportunity ${String(row.getValue('name') ?? '')}`}
              >
                {content}
              </Link>
            ) : (
              <div className="px-3 py-3">{content}</div>
            )}
          </TableCell>
        );
      })}
    </TableRow>
  );
}
